import {PipelineStepType} from 'graphql-client/__generated/graphqlGlobalTypes';
import {deriveStepUiSchema} from 'pipelines/generalized-step-config-editor/step-config-settings/deriveStepUiSchema';
import {getStepTypeConfigShape} from 'pipelines/StepShapeUtils';

import PlateSizeEditor from '../editors/custom-editors/PlateSizeEditor';
import {StepTypeConfigUISchemaV2} from '../step-config-settings/StepConfigUISchemas';
import {CUSTOM_COMPONENT_KEY, FIELD_ORDER_UI_SCHEMA_KEY} from '../StepConfigEditorTypes';

const TRANSFER_PLATES_BASE_UI_SCHEMA = deriveStepUiSchema(
  getStepTypeConfigShape(PipelineStepType.TRANSFER_PLATES, 0).fields
);

export const TRANSFER_PLATES_V0_UI_SCHEMA = {
  ...TRANSFER_PLATES_BASE_UI_SCHEMA,
  [FIELD_ORDER_UI_SCHEMA_KEY]: ['name', 'plateHeight', 'columnMapping'],
  plateHeight: {
    ...TRANSFER_PLATES_BASE_UI_SCHEMA.plateHeight,
    displayName: 'Plate size',
    [CUSTOM_COMPONENT_KEY]: PlateSizeEditor,
  },
  columnMapping: {
    ...TRANSFER_PLATES_BASE_UI_SCHEMA.columnMapping,
    fieldSettings: {
      subfieldInfoText: {
        source_plate_id:
          'API ID of an existing plate to source from — set this or a source destination plate index, not both',
        source_destination_plate_index:
          'Index of a destination plate filled earlier in this step to source from, for serial dilutions — set this or a source plate, not both',
        destination_plate_index:
          'Groups rows into destination plates — rows sharing an index fill the same plate',
        transfer_amount:
          'Amount to transfer from the source well — its unit id and version are required when set',
        diluent_amount:
          'Amount of diluent to add to the destination well — its unit id and version are required when set',
        diluent_entity_id:
          'API ID of the material the diluent is (water, buffer, …) — records it as its own content in the destination well, and requires a diluent amount',
        final_volume_amount:
          'Target total volume in the destination well after transfer and diluent — its unit id and version are required when set',
      },
    },
  },
} as StepTypeConfigUISchemaV2<PipelineStepType.TRANSFER_PLATES, 0>;
